import { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

class Dialog extends Component {
    hiddenClass = 'dialog--hidden'

    constructor(props) {
        super(props)
        this.overlayEl = document.createElement('div')
        this.overlayEl.classList.add('dialog')
        this.overlayEl.classList.add(this.hiddenClass)
    }

    renderDialog = () => {
        let { className } = this.props

        return (
            <div className="dialog__buffer">
                <div className={'dialog__content ' + (className || '')}>
                    {this.props.children}
                </div>
            </div>
        )
    }

    render() {
        const { open, onClose } = this.props

        open ? 
            this.overlayEl.classList.remove(this.hiddenClass) :
            this.overlayEl.classList.add(this.hiddenClass)

        this.overlayEl.addEventListener('click', (e) => {
            if (e.target === this.overlayEl)
                onClose()
            // else { clicked on .dialog__content }
        })

        return ReactDOM.createPortal(
                this.renderDialog(),
                this.overlayEl)
    }

    componentDidMount() {
        document.body.appendChild(this.overlayEl)
    }

    componentWillUnmount() {
        document.body.removeChild(this.overlayEl)
    }
}

Dialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
}

export default Dialog